// extracted by mini-css-extract-plugin
export default {"root":"CodeInput_root__iOneD","root_digit":"CodeInput_root_digit__rSzX0","root_digit_error":"CodeInput_root_digit_error__NZBMN"};